export enum Locale {
  EN = "en",
  PL = "pl",
}
